import {
  PERIOD,
  APPLICATIONS,
  IMPORTANCE_TYPE,
  DESCRIPTION,
  INVOICES,
  BUSINESS_PARTNER,
  AFFILIATES,
  EXPENSE_TYPE,
} from 'scenes/FinancialResults/components/FinancialResultForm/constants';

const Scope = [PERIOD, APPLICATIONS, IMPORTANCE_TYPE];
const All = [PERIOD, APPLICATIONS, IMPORTANCE_TYPE, DESCRIPTION, INVOICES];
const Draft = [
  BUSINESS_PARTNER,
  AFFILIATES,
  EXPENSE_TYPE,
  PERIOD,
  APPLICATIONS,
  IMPORTANCE_TYPE,
  DESCRIPTION,
  INVOICES,
];
const Invoices = [INVOICES];

export default function getAction(granularity) {
  const parts = granularity.split(', ');
  return parts.reduce((actions, flag) => {
    switch (flag) {
      case 'draft':
        return [...actions, ...Draft];
      case 'all':
        return [...actions, ...All];
      case 'invoices':
        return [...actions, ...Invoices];
      case 'scope':
        return [...actions, ...Scope];
      default:
        return actions;
    }
  }, []);
}
